import { VideoPlayer } from '@helpers/VideoPlayer';

class VimeoVideo extends VideoPlayer {
  constructor(iframe: HTMLIFrameElement) {
    super(new window.Vimeo.Player(iframe));
  }

  onPlayVideo() {
    this?._player
      ?.play()
      .then()
      .catch((error: unknown) => {
        console.log(error);
      });
  }

  onPauseVideo() {
    this?._player
      ?.pause()
      .then()
      .catch((error: unknown) => {
        console.log(error);
      });
  }

  onStopVideo() {
    this?._player
      .unload()
      .then()
      .catch((error: unknown) => {
        console.log(error);
      });
  }
}

export { VimeoVideo };
